export default () => ({
  country: "bil",
  intl: {
    fallbackLng: "bs",
    locales: [
      {
        locale: "bs",
        label: "Bosnia"
      }
    ]
  },
  api: {
    user: {
      workZipCode: "BIL"
    }
  },

  serverTimeZone: 2,

  footer: {
    copyright: "© CINEPLEXX d.o.o.",
    apps: {
      android: "https://play.google.com/store/apps/details?id=ba.cineplexx.app",
      ios: "https://itunes.apple.com/app/id1503245588"
    }
  },

  supportInfo: {
    contactUs: {
      email: "info@cineplexxpalas.ba"
    }
  },

  form: {
    validation: {
      zip: 5
    }
  },

  wizard: {
    stepTickets: {
      warnings: {
        en: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Attention!</span></strong> The 1 + 1 offer is only available at <strong>Cineplexx Titan (Bucharest)</strong> for tickets purchased at the desk, not online!',
            description:
              "Pay at the cinema to receive a bonus ticket for every cinema ticket purchased"
          }
        ],
        bs: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Atenție!</span></strong> Oferta 1 + 1 este disponibilă doar la <strong>Cineplexx Titan (București)</strong> pentru biletele achiziționate la casele de bilete, nu și online!',
            description:
              "Pentru a beneficia de un bilet bonus pentru fiecare bilet de film cumpărat, plătește la cinema."
          }
        ]
      }
    },
    stepCheckout: {
      messages: {
        en: [
          "Tickets purchased online cannot be changed or canceled and their value will not be refunded."
        ],
        bs: [
          "Ulaznice kupljene online ne mogu biti promijenjene, otkazane ili refundirane."
        ]
      }
    }
  },
  showingOptions: {
    member: true,
    giftcards: false,
    streaming: false,
    cinemaRent: false,
    advertising: true,
    newsletter: false,
    newsletterfooter: false,
    newsletterpopup: false,
    information: true,
    followUs: true,
    wishToReceiveSMS: false,
    contactByThirdParty: false,
    myBonusCard: false,
    myGiftCard: false,
    displayTechnologies: false,
    privacyPolicy: true,
    b2bAdvertising: true,
    weeklynewsletter: true,
    familynewsletter: true,
    operanewsletter: true,
    ageratingvisible: false,
    schoolcinema: true,
    childtickets: true,
    company: {
      press: false,
      portrait: false,
      jobs: false
    },
    refundTickets: false,
    club: {
      bonusCard: false,
      familyFilmclub: false,
      competitions: false
    },
    giftCards: {
      giftcardShop: false,
      giftcardInfo: false
    }
  }
});
